// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import cx from 'classnames';
import numbersForPaginationLinks from 'lib/numbersForPaginationLinks';

/** @type { StatelessComponent<{ currentPageNum: number, linkNum: number, onClick: (pageNum: number) => any }> } */
const NumberLink = ({ currentPageNum, linkNum, onClick }) => {
  const classes = cx({ current: currentPageNum === linkNum });
  const handleClick = () => {
    if (currentPageNum !== linkNum) {
      onClick(linkNum);
    }
  };

  return (
    <li className={classes}>
      <span onClick={handleClick}>{linkNum}</span>
    </li>
  );
};

NumberLink.displayName = 'NumberLink';

NumberLink.propTypes = {
  currentPageNum: PropTypes.number.isRequired,
  linkNum: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

/** @type { StatelessComponent<{ id?:string, pageNum: number, totalPages: number, onPageClick: (pageNum: number) => any}> } */
const PaginationLinks = ({ id, pageNum, totalPages, onPageClick }) => {
  const canPrevPage = pageNum > 1;
  const canNextPage = totalPages > pageNum;

  const prevClasses = cx({ disabled: !canPrevPage });
  const nextClasses = cx({ disabled: !canNextPage });

  const handleFirstPageClick = () => {
    if (canPrevPage) {
      onPageClick(1);
    }
  };
  const handlePrevPageClick = () => {
    if (canPrevPage) {
      onPageClick(pageNum - 1);
    }
  };
  const handleNextPageClick = () => {
    if (canNextPage) {
      onPageClick(pageNum + 1);
    }
  };
  const handleLastPageClick = () => {
    if (canNextPage) {
      onPageClick(totalPages);
    }
  };

  return (
    <div id={id} data-spec-class="pagination" className="PaginationLinks pagination-centered">
      <ol>
        <li key="first" className={prevClasses}>
          <span onClick={handleFirstPageClick}>&laquo; First</span>
        </li>
        <li key="prev" className={prevClasses}>
          <span onClick={handlePrevPageClick} className="fake-link">
            &lsaquo; Prev
          </span>
        </li>
        {numbersForPaginationLinks(pageNum, totalPages).map(linkNum => (
          <NumberLink
            key={linkNum}
            currentPageNum={pageNum}
            linkNum={linkNum}
            onClick={onPageClick}
          />
        ))}
        <li key="next" className={nextClasses}>
          <span onClick={handleNextPageClick} data-spec-id="next-link" className="fake-link">
            Next &rsaquo;
          </span>
        </li>
        <li key="last" className={nextClasses}>
          <span onClick={handleLastPageClick}>Last &raquo;</span>
        </li>
      </ol>
    </div>
  );
};

PaginationLinks.displayName = 'PaginationLinks';

PaginationLinks.propTypes = {
  id: PropTypes.string,
  pageNum: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageClick: PropTypes.func.isRequired,
};

export default PaginationLinks;
